import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useReopenSession = () => {
  const handleErrors = useQueryErrorHandling();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.post("onboarding/session/me/reopen"),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: onboardingQKeys.session() });
    },
    onError: (res: any) => handleErrors(res, "mutation"),
  });
};
